<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <h1>
          Welkom bij Humanwise!
        </h1>
      </v-col>

      <v-col cols="12" class="mb-4">
        Heb je al een account? Log dan hier in
      </v-col>

      <v-col cols="12" class="bm-4">
        <!-- Step 1: Email -->
        <div v-if="step === 1">
          <form v-on:submit.prevent="" v-on:keyup.enter="requestToken">
            <v-text-field
                v-model="form.email"
                label="Email"
                required
                :disabled="loading"
            ></v-text-field>

            <v-btn color="accent" class="mr-4" block @click="requestToken" :loading="loading" :disabled="loading">Doorgaan</v-btn>
          </form>
        </div>

        <!-- Step 2: Token -->
        <div v-if="step === 2">
          <p class="mb-6">Er is een 6-cijferige code naar <strong>{{ form.email }}</strong> verstuurd</p>

          <form v-on:submit.prevent="" v-on:keyup.enter="verifyToken">
            <v-text-field
                v-model="form.login_token"
                label="Login code"
                placeholder="000000"
                maxlength="6"
                required
                :disabled="loading"
            ></v-text-field>

            <v-btn color="accent" class="mr-4" block @click="verifyToken" :loading="loading" :disabled="loading">Inloggen</v-btn>
          </form>

          <div class="mt-4">
            <a @click="goBackToEmail" class="float-left">Terug</a>
            <v-btn
              text
              small
              color="accent"
              @click="resendToken"
              :disabled="resendDisabled || loading"
            >
              Opnieuw versturen{{ resendCounter > 0 ? ` (${resendCounter}s)` : '' }}
            </v-btn>
          </div>
        </div>
      </v-col>

      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="mb-4">
        <p>
          Je kunt inloggen met het e-mailadres dat bij Humanwise bekend is.
          <br />
          Mits je organisatie toegang tot de Humanwise app heeft.
        </p>
      </v-col>

      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="mb-1">
        Heb je nog geen Humanwise profiel? Vraag dan de benodigde informatie aan.
      </v-col>
      <v-col cols="12" class="mb-4">
        <v-btn color="accent" class="mr-4" @click="informationRequest">Informatie aanvragen</v-btn>
      </v-col>

      <snackbar-text :text="error.message" bg-color="red" text-color="white" v-model="error.show"/>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions} from "vuex";
import SnackbarText from "@/components/snackbar-text";

export default {
  name: "Login",
  components: {SnackbarText},
  data: () => ({
    step: 1,
    form: {
      email: null,
      login_token: null,
    },
    error: {
      show: false,
      message: ""
    },
    loading: false,
    resendDisabled: false,
    resendCounter: 0,
    resendInterval: null,
  }),
  beforeDestroy() {
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
    }
  },
  methods: {
    ...mapActions({
      requestLoginToken: 'auth/requestLoginToken',
      verifyLoginToken: 'auth/verifyLoginToken',
      resendLoginToken: 'auth/resendLoginToken',
    }),
    requestToken() {
      if (!this.form.email) {
        this.error.message = "Voer je emailadres in";
        this.error.show = true;
        return;
      }

      this.loading = true;

      this.requestLoginToken({email: this.form.email}).then(() => {
        this.step = 2;
        this.form.login_token = null;
        this.startResendTimer();
        this.loading = false;
      }).catch((err) => {
        if (err.status === 400) {
          this.error.message = "Geen account gevonden voor dit emailadres";
        } else if (err.status === 302) {
          this.error.message = "Helaas, je hebt geen toegang tot de Humanwise app.";
        } else {
          this.error.message = "Er is een onbekende fout opgetreden! Als dit probleem zich blijft voordoen neem dan contact met ons op";
        }

        this.error.show = true;
        this.loading = false;
      });
    },
    verifyToken() {
      if (!this.form.login_token) {
        this.error.message = "Voer je login code in";
        this.error.show = true;
        return;
      }

      this.loading = true;

      this.verifyLoginToken({email: this.form.email, login_token: this.form.login_token}).then(() => {
        this.$router.push({name: 'dashboardHome'})
      }).catch((err) => {
        if (err.status === 400) {
          this.error.message = "Ongeldige of verlopen code, probeer opnieuw";
        } else if (err.status === 302) {
          this.error.message = "Helaas, je hebt geen toegang tot de Humanwise app.";
        } else {
          this.error.message = "Er is een onbekende fout opgetreden! Als dit probleem zich blijft voordoen neem dan contact met ons op";
        }

        this.error.show = true;
        this.loading = false;
      });
    },
    goBackToEmail() {
      this.step = 1;
      this.form.login_token = null;
      if (this.resendInterval) {
        clearInterval(this.resendInterval);
        this.resendInterval = null;
      }
      this.resendCounter = 0;
      this.resendDisabled = false;
    },
    resendToken() {
      this.loading = true;

      this.resendLoginToken({email: this.form.email}).then(() => {
        this.error.message = "Code opnieuw verstuurd naar " + this.form.email;
        this.error.show = true;
        this.loading = false;
        this.startResendTimer();
      }).catch((err) => {
        this.error.message = "Fout bij het verzenden van de code. Probeer later opnieuw.";
        this.error.show = true;
        this.loading = false;
      });
    },
    startResendTimer() {
      this.resendDisabled = true;
      this.resendCounter = 60;

      if (this.resendInterval) {
        clearInterval(this.resendInterval);
      }

      this.resendInterval = setInterval(() => {
        this.resendCounter -= 1;
        if (this.resendCounter <= 0) {
          clearInterval(this.resendInterval);
          this.resendInterval = null;
          this.resendDisabled = false;
          this.resendCounter = 0;
        }
      }, 1000);
    },
    informationRequest() {
      this.$router.push({name: 'informationRequest'})
    }
  },
};
</script>
